import { Flex, Text } from "styles/utility-components";

import { Currency } from "components/app_layout/Typography";

type Props = {
  transactionCount?: number;
  totalValue?: number;
};

/**
 * The spend page's headline: the transactions the filters match and what they come to.
 * Both views are cuts of these same transactions, so this does not move when the view or
 * the pivot does — only the filters change it.
 */
export function SpendResultsSummary({ transactionCount, totalValue }: Props) {
  if (transactionCount === undefined) {
    return null;
  }
  return (
    <Flex alignItems="center" gap={8}>
      <Text color="sysTextSecondary">
        Total number of transactions: {transactionCount.toLocaleString("en-GB")}
      </Text>
      {totalValue !== undefined && (
        <>
          <Text color="sysTextSecondary">·</Text>
          <Text color="sysTextSecondary">
            Total value: <Currency value={totalValue} />
          </Text>
        </>
      )}
    </Flex>
  );
}
